/** @jsx jsx */
import { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/core';

const fadeInCss = loaded => css`
  opacity: ${loaded ? 1 : 0};
  transition: opacity 350ms ease;
`;

const Img = ({ css, src, alt, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(
    () => {
      const image = new Image();
      image.src = src;
      image.onload = () => setLoaded(true);
      if (image.complete) setLoaded(true);
    },
    [src]
  );

  return (
    <img css={{ ...fadeInCss(loaded), ...css }} src={src} alt={alt} {...rest} />
  );
};

export default Img;
